export default {
  TRAININGS: "Formation",
  NAVBAR_TOOLTIP: "Formation et aide",
  HELP: "Aide",
  HELP_FOR: "Aide : {topic}",

  CONTEXT_PURCHASES_ORDERS: "Commandes d'achat",
  CONTEXT_PURCHASES_ORDERS_WHERE:
    "Établissement › Commandes achat · Achats › Commandes achat",
  CONTEXT_PURCHASES_ORDER_RECEPTION: "Réception d'une commande d'achat",
  CONTEXT_PURCHASES_ORDER_RECEPTION_WHERE:
    "Commande d'achat › Confirmer la réception",
  CONTEXT_SALES_ORDERS: "Soumissions",
  CONTEXT_SALES_ORDERS_WHERE:
    "Établissement › Soumissions · Ventes › Soumissions",
  CONTEXT_CASH_REGISTER_READINGS: "Lectures de caisse",
  CONTEXT_CASH_REGISTER_READINGS_WHERE: "Ventes › Lectures de caisse",
  CONTEXT_INVENTORY: "Inventaire",
  CONTEXT_INVENTORY_WHERE:
    "Inventaire › Formation · Mouvements de stock · Entrepôts",
  CONTEXT_INTERNAL_ORDERS: "Commandes internes",
  CONTEXT_INTERNAL_ORDERS_WHERE:
    "Établissement › Commandes internes · Inventaire › Commande interne",
  CONTEXT_ESTABLISHMENT_TRANSFERS: "Transferts",
  CONTEXT_ESTABLISHMENT_TRANSFERS_WHERE:
    "Établissement › Transferts · Inventaire › Transferts",
  CONTEXT_INTERNAL_INVOICES: "Factures internes",
  CONTEXT_INTERNAL_INVOICES_WHERE:
    "Établissement › Factures internes · Inventaire › Factures internes",
  CONTEXT_WEEKLY_REPORTS: "Rapports hebdomadaires",
  CONTEXT_WEEKLY_REPORTS_WHERE: "Cafétéria › Rapports hebdomadaires",

  TAB_ALL: "Toutes les formations",
  TAB_MY_PATH: "Mon parcours",
  TAB_HELP_LINKS: "Aide par écran",
  TAB_PATHS: "Parcours par rôle",
  TAB_FOLLOW_UP: "Suivi des employés",

  NO_HELP: "Aucune formation n'est encore disponible.",
  NO_FILES: "Aucun fichier.",
  SEEN: "Vu",
  MARK_AS_SEEN: "Marquer comme vu",
  WATCH_TO_THE_END: "À regarder jusqu'au bout",
  WATCH_REQUIRED:
    "Vu à {percent} % · La vidéo se cochera toute seule à la fin. L'avance rapide est désactivée.",
  VIDEO_COMPLETED: "Vidéo terminée : elle est cochée comme vue.",
  SEEN_ON: "Vu le {date}",
  OPEN_IN_NEW_TAB: "Ouvrir dans un nouvel onglet",
  DOWNLOAD: "Télécharger",
  NOT_PREVIEWABLE:
    "Ce fichier ne s'affiche pas dans le navigateur : téléchargez-le pour l'ouvrir.",
  CHOOSE_A_FILE: "Choisissez un fichier dans la liste.",

  MY_PATH_EMPTY:
    "Aucun parcours de formation n'est prévu pour votre rôle pour le moment.",
  MY_PATH_PROGRESS: "{completed} sur {total} vus",
  MY_PATH_DONE: "Vous avez terminé votre parcours de formation.",

  WELCOME_TITLE: "Votre parcours de formation",
  WELCOME_TEXT:
    "Des vidéos et des guides vous montrent comment utiliser le logiciel. Regardez-les dans l'ordre et cochez chacun une fois vu.",
  WELCOME_TEXT_WATCH:
    "Des vidéos et des guides vous montrent comment utiliser le logiciel. Regardez-les dans l'ordre : chaque vidéo se coche toute seule une fois regardée jusqu'au bout, et vous cochez les guides une fois lus.",
  WELCOME_START: "Commencer ma formation",
  WELCOME_CONTINUE: "Poursuivre ma formation",
  WELCOME_LATER: "Plus tard",

  HELP_LINKS_DESCRIPTION:
    "Choisissez les fichiers de l'explorateur que le bouton « ? » affiche sur chaque écran, dans l'ordre. Remplacer un fichier dans l'explorateur met l'aide à jour automatiquement.",
  PATHS_DESCRIPTION:
    "Choisissez, pour chaque rôle, les fichiers qu'un nouvel employé doit voir, dans l'ordre. Le parcours s'affiche à sa connexion tant qu'il n'a pas tout coché.",
  SHOWN_ON: "Affiché sur : {where}",
  ADD_FILE: "Ajouter un fichier",
  SEARCH_FILE: "Rechercher un fichier de l'explorateur",
  MOVE_UP: "Monter",
  MOVE_DOWN: "Descendre",
  REMOVE: "Retirer",
  SAVED: "Modifications enregistrées",
  UNSAVED_CHANGES: "Modifications non enregistrées",
  SELECT_ROLE: "Choisir un rôle",
  ROLE_ACTIVE_USERS:
    "aucun employé actif | {count} employé actif | {count} employés actifs",
  ROLE_FILES: "aucun fichier | {count} fichier | {count} fichiers",

  FOLLOW_UP_DESCRIPTION:
    "Employés actifs dont le rôle a un parcours de formation. La relance envoie un avis dans le logiciel et un courriel.",
  NO_FOLLOW_UP: "Aucun parcours de formation n'est encore configuré.",
  EMPLOYEE: "Employé",
  PROGRESS: "Avancement",
  FINISHED_ON: "Terminé le",
  LAST_REMINDER: "Dernière relance",
  REMIND: "Relancer",
  REMIND_CONFIRM:
    "Envoyer un rappel à {name} ? Un avis s'affichera dans le logiciel et un courriel lui sera envoyé.",
  REMINDED: "Rappel envoyé à {name}",
  FILTER_TO_FINISH: "À terminer",
  FILTER_FINISHED: "Terminé",
  SEARCH_EMPLOYEE: "Rechercher un employé",
  EXEMPT: "Dispensé",
  EXEMPT_TOOLTIP: "Peut cocher les vidéos sans les regarder en entier",

  SETTINGS: "Réglages",
  SETTINGS_TITLE: "Réglages des formations",
  SETTINGS_DESCRIPTION:
    "Ces réglages s'appliquent à tous les employés de l'organisation.",
  FORCE_VIDEO_COMPLETION: "Exiger de regarder les vidéos jusqu'au bout",
  FORCE_VIDEO_COMPLETION_HELP:
    "L'avance rapide est bloquée et une vidéo se coche toute seule à la fin. Les vidéos déjà cochées le restent. Les guides (PDF, documents) se cochent toujours à la main.",
  EXEMPT_USERS: "Employés dispensés",
  EXEMPT_USERS_HELP:
    "Employés déjà formés : ils avancent librement dans les vidéos et les cochent sans les regarder en entier.",
  SELECT_EMPLOYEES: "Choisir des employés",
};
